import React, { useCallback } from 'react';
import './styles.scss';

export const LoadingSection = (props: any) => {
  const inClass = props.className || '';
  
  return (
    <div id="section-loading" className={`loading-section ${inClass}`}>
      <div className="loading-icon"></div>
      Cargando...
    </div>
  )
}
